<form [formGroup]="issueTicketsForm">
  <div id="paypn" class="container-fluid mt-10">
    <div>
      <h4 class="mt-0">Issue Tickets Total</h4>
      <div class="paypn">
        <div id="paydetail">
          <!-- <div class="row">
                        <div class="col-sm-12">
                            <div id="errFm" class="smx red hide mb-10"><i class="fa fa-times fa-lg"></i>Error : Not all
                                details provided. Please complete form </div>

                        </div>

                    </div> -->

          <input type="hidden" id="amount" name="amount" value="665.14" />
          <div class="row">
            <div class="col-sm-8">
              <div class="radio-toolbar">
                <input type="radio" id="paycash" name="payT" value="CASH" checked="checked" />
                <label for="paycash">Cash</label>
                <input type="radio" id="paycc" name="payT" value="CC" />
                <label for="paycc">Credit Card</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-lg-4 col-sm-4">
              <h4>Payer</h4>
              <!-- <div id="pnpaxpayr" class="mb-10 hide">
                                <select id="paxpayer" name="paxpayer" class="form-control">
                                    <option value="T2">FNTESTA LNTESTA</option>
                                </select>
                            </div> -->
              <div id="pnpayr">
                <input type="text" id="payfname" name="payfname" placeholder="FirstName" class="form-input" />

                <input type="text" id="paylname" name="paylname" placeholder="LasttName" class="form-input" />
              </div>
              <div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="pull-right">
                      <div class="toggle btn btn-default off btn-sm" data-bs-toggle="toggle" style="width: 140px; height: 34.2014px">
                        <input
                          id="chkpayer"
                          name="chkpayer"
                          type="checkbox"
                          class="toggle2"
                          data-on="Passenger"
                          data-bs-toggle="toggle"
                          data-size="small"
                          data-width="140"
                          data-off="3rd Party Payer "
                          onchange="setpayer();"
                        />
                        <div class="toggle-group">
                          <label class="btn btn-primary btn-sm toggle-on">Passenger</label><label class="btn btn-default btn-sm active toggle-off">3rd Party Payer </label
                          ><span class="toggle-handle btn btn-default btn-sm"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <input id="chkpayerref" name="chkpayerref" type="hidden" />
              </div>

              <h4>Address</h4>

              <input type="text" id="ad1" name="ad1" placeholder="address 1" value="ADDRESS1" class="form-control" />
              <input type="text" id="ad2" name="ad2" placeholder="address 2" value="ADDRESS2" class="form-control" />
              <input type="text" id="city" name="city" placeholder="city" value="CITY" class="form-control" />
              <div class="row">
                <div class="col-sm-8"><input type="text" id="state" name="state" value="STATE" placeholder="state/county" class="form-control" /></div>
                <div class="col-sm-4"><input type="text" id="zip" name="zip" value="ZIP" placeholder="zip" class="form-control" /></div>
              </div>

              <select id="countrycode" name="countrycode" class="form-control form-select">
                <option *ngFor="let country of countries" [value]="country.value">{{ country.name }}</option>
              </select>
              <ngx-intl-tel-input
                [cssClass]="'custom form-control'"
                [preferredCountries]="preferredCountries"
                [enableAutoCountrySelect]="true"
                [enablePlaceholder]="true"
                [searchCountryFlag]="true"
                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                [selectFirstCountry]="false"
                [selectedCountryISO]="CountryISO.UnitedKingdom"
                [maxLength]="15"
                [phoneValidation]="true"
                [separateDialCode]="separateDialCode"
                [numberFormat]="PhoneNumberFormat.National"
                name="phone"
                formControlName="phone"
              >
              </ngx-intl-tel-input>
              <input type="hidden" id="phone" name="phone" />
              <input type="hidden" id="telCountryCode" name="telCountryCode" />
            </div>

            <div class="col-md-8 col-lg-8 col-sm-8">
              <div class="col-md-12 col-lg-6 col-sm-12">
                <div class="row">
                  <div class="col-sm-7">
                    <h4>Card Details</h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-10">
                    <select id="ccType" name="ccType" class="form-control mb-16">
                      <option value="VI1">Visa Credit ( 0 )</option>
                      <option value="CA2">MasterCard ( 0 )</option>
                      <option value="DS3">Discover ( 0 )</option>
                      <option value="DC4">Diners Club ( 0 )</option>
                      <option value="AX5">American Express ( 0 )</option>
                      <option value="TP6">Airplus/UATP ( 0 )</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-10">
                    <input type="text" id="cardnum" list="cc-list" name="cardnum" placeholder="Card Number" class="form-control" />
                    <datalist id="cc-list">
                      <option value="5200000000000007"></option>
                      <option value="4000000000001091"></option>
                      <option value="4000000000000101"></option>
                      <option value="344400000000569"></option>
                    </datalist>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3">
                    <input type="text" id="expmm" name="expmm" placeholder="MM" class="form-control wd65" maxlength="2" />
                  </div>
                  <div class="col-sm-3 pl-0">
                    <input type="text" id="expyy" name="expyy" placeholder="YY" class="form-control wd65" maxlength="2" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3">
                    <input type="text" id="cv2" name="cv2" placeholder="cv2" class="form-control" maxlength="4" />
                  </div>
                  <div class="col-sm-7">
                    <div class="pull-right">
                      <div class="toggle btn btn-default off btn-sm" data-bs-toggle="toggle" style="width: 80px; height: 34.2014px">
                        <input id="chkOnline" class="toggle2" data-on="Online" data-bs-toggle="toggle" data-size="small" data-width="80" data-off="OffLine" name="chkOnline" type="checkbox" />
                        <div class="toggle-group">
                          <label class="btn btn-primary btn-sm toggle-on">Online</label><label class="btn btn-default btn-sm active toggle-off">OffLine</label
                          ><span class="toggle-handle btn btn-default btn-sm"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-6 col-sm-12">
                <div id="totpaypn">
                  <div class="pnfin">
                    <h4>Total Due</h4>
                    <div class="row">
                      <div class="col-sm-4">Flights</div>
                      <div class="col-sm-7 txtRt pr-2">0.00</div>
                      <div class="col-sm-1 pr-2"></div>
                    </div>
                    <div class="row">
                      <div class="col-sm-7">Seats</div>
                      <div class="col-sm-4 pl-0 txtRt pr-2">0.00</div>
                      <div class="col-sm-1 pr-2"></div>
                    </div>
                    <div class="row">
                      <div class="col-sm-7">Services (Meals/Bags)</div>
                      <div class="col-sm-4 pl-0 txtRt pr-2">0.00</div>
                      <div class="col-sm-1 pr-2"></div>
                    </div>

                    <div class="row">
                      <div class="col-sm-7">Card Fee</div>
                      <div class="col-sm-4 txtRt pl-0 pr-2"></div>
                      <div class="col-sm-1 pr-2"></div>
                    </div>

                    <div class="row">
                      <div class="col-sm-2"><b>Total</b></div>
                      <div class="col-sm-9 pl-0 pr-0">
                        <div class="flPrice txtRt">665.14</div>
                      </div>
                      <div class="col-sm-1 pull-right pl-0 pr-2">
                        <span class="smcur"> USD </span>
                      </div>
                    </div>
                  </div>

                  <div class="mt-20">
                    <button type="button" role="button" class="ba-btn ba-btn-thin pull-right" onclick="doAirDocIssue(); return false;"><i class="fa fa-shopping-cart"></i> Book</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
